module.exports = __webpack_public_path__ + "img/左右翻转3.3104ed45.svg";